import { type ReactNode } from "react";

import { Heading, Paragraph } from "common/core/typography";
import { useId } from "util/html";

import Styles from "./charts_section.module.scss";

export type ChartsSectionSize = "Small" | "Medium" | "Large";

type ChartsSectionProps = {
  heading: string;
  description: string;
  firstChart: ReactNode;
  secondChart: ReactNode;
  sectionSize?: ChartsSectionSize;
};

export function ChartsSection({
  heading,
  description,
  firstChart,
  secondChart,
  sectionSize = "Medium",
}: ChartsSectionProps) {
  const chartsSectionHeadingId = useId();
  return (
    <>
      <div className={Styles.header}>
        <Heading id={chartsSectionHeadingId} level="h2" textStyle="headingFour">
          {heading}
        </Heading>
        <Paragraph textColor="subtle">{description}</Paragraph>
      </div>
      <div
        aria-describedby={chartsSectionHeadingId}
        className={`${Styles.container} ${Styles[`container${sectionSize}`]}`}
      >
        <div className={Styles.card}>{firstChart}</div>
        <div className={Styles.card}>{secondChart}</div>
      </div>
    </>
  );
}
